<template>
  <div class="index-page"></div>
</template>

<script>

export default {
  name: 'Index',
  data () {
    return {}
  },
  mounted() {
    if((/MicroMessenger/ig).test(navigator.userAgent)) {
      const tp = 'weixin-mp-pd'
      const href = location.href.split('#')[0] + '#/video'
      window.location.href = `http://dict.youdao.com/login/acc/login?app=web&product=DICT&tp=${tp}&fr=1&cf=7&ru=${encodeURIComponent(href)}`
    } else {
      this.$router.replace('/video')
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.index-page{
    width: 100%;
    height: 100%;
    background: url(../assets/loadingBg.png) 0 0/100% 100% no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue